
export function distinct<TArr>(arr: TArr[], keyFunc: ((t: TArr) => number)): TArr[] {
    const result: TArr[] = [];
    const keys: { [k: number]: true } = {};
    for (let item of arr) {
        const key = keyFunc(item);
        if (keys[key])
            continue;
        keys[key] = true;
        result.push(item);
    }
    return result;
}
